var hashtag_default = {
  "fontElementMap": "DgbLj",
  "hashtag": "H6qza"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
